import { render, staticRenderFns } from "./BrandServiceCard.vue?vue&type=template&id=3cef0317&scoped=true&"
import script from "./BrandServiceCard.vue?vue&type=script&lang=ts&"
export * from "./BrandServiceCard.vue?vue&type=script&lang=ts&"
import style0 from "./BrandServiceCard.vue?vue&type=style&index=0&id=3cef0317&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cef0317",
  null
  
)

export default component.exports